export class Sell {
    amount: number;
    carrier: string;
    comision: number;
    confirmation: string;
    date_hour: string;
    description: string;
    destination: string;
    id_pinusr: string;
    origin: string;
    rcode: number;
    sku: string;
    tx_id: number;
    reference: string;
    uid: string;
    operation_id:number;

    constructor({
        amount = 0,
        carrier = "",
        comision = 0,
        confirmation = "",
        date_hour = "",
        description = "",
        destination = "",
        id_pinusr = "",
        origin = "",
        rcode = 0,
        sku = "",
        tx_id = 0,
        mov_description = undefined,
        mov_reference = undefined,
        uid = "",
        operation_id = undefined
    }: any) {
        this.amount = amount;
        this.carrier = carrier;
        this.comision = comision;
        this.confirmation = confirmation;
        this.date_hour = date_hour;
        this.description = mov_description ?? description;
        this.destination = destination;
        this.id_pinusr = id_pinusr;
        this.origin = origin;
        this.rcode = rcode;
        this.sku = sku;
        this.tx_id = tx_id;
        this.reference = mov_reference;
        this.uid = uid;
        this.operation_id = operation_id;
    }

}